import useConfigureAxios from "@FRAMEWORK/utils/useConfigureAxios";
import publicRuntimeConfig from "@FRAMEWORK/config/public";
import {Response} from "@QUERIES/types";
import {UseQueryOptions, useQuery} from "@tanstack/react-query";

interface Traffic {
	trCompanyNm: string;
	trCompanySnm: string;
	trTp: string;
}
interface Accommodation {
	accomSeq: number;
	accomNm: string;
}

interface GoodsOption {
	trafficList: Array<Traffic>;
	accommodationList: Array<Accommodation>;
}

/** ```
 * 상품에 설정된 옵션
 *   `/prdt/api/goods/${goodsCd}/option`
 * parameter
 *   `goodsCd` 상품코드
 * ```*/
const key = "useGoodsOption";
const getPath = (goodsCd: string): string | null => {
	if (!goodsCd) return null;
	return `${publicRuntimeConfig.ENV_PRODUCT_API_BASEPATH}/api/goods/${goodsCd}/option`;
};

/** ```
 * 상품에 설정된 옵션
 *   `/prdt/api/goods/${goodsCd}/option`
 * parameter
 *   `goodsCd` 상품코드
 * ```*/
const useGoodsOption = (goodsCd: string, options?: Partial<UseQueryOptions<Response<GoodsOption>, Error>>) =>
	useQuery({
		queryKey: [key, getPath(goodsCd)],
		queryFn: () => useConfigureAxios({url: getPath(goodsCd)}).then(r => r.data),
		staleTime: 1000 * 30 * 60,
		...options,
	});

export default useGoodsOption;
export {getPath, key};
export type {Traffic, Accommodation, GoodsOption};
